import {create} from "zustand";
import {persist} from "zustand/middleware";

// Réglage propre à chaque tablette ou PC : revenir aux cartes complètes sans redéployer si l'atelier préfère.
const useDisplaySettingsStore = create(persist(
    (set) => ({
        showAllTasksInCards: false,
        toggleShowAllTasksInCards: () => set((state) => ({showAllTasksInCards: !state.showAllTasksInCards})),
    }),
    {name: "print-display-settings"}
))

export default useDisplaySettingsStore
